import React from 'react';
import {
    HeroMain,
    HeroContent,
    MainTitle,
    WelcomeNote,
    WhyUsContainer,
    WhyUsCard,
    CallToAction,
    ContactButton
} from './HeroElements';

const HeroSection = () => {
    return (
        <HeroMain id='Home'>
            <HeroContent>
                <MainTitle>Prorenova</MainTitle>
                
                <WelcomeNote>
                    <h2>Welcome to ProRenova – Your Trusted Carpentry and Renovation Experts.</h2>
                    <p>
                        At ProRenova, we transform spaces with precision, craftsmanship, and a passion for quality. 
                        Whether you’re looking to upgrade your home, renovate your restaurant, or create custom furniture, 
                        we’ve got you covered. From laminate flooring and parqueting to kitchen installations, 
                        wooden decks, pergolas, and custom cashier builds, we bring your vision to life with 
                        unmatched skill and attention to detail.
                    </p>
                </WelcomeNote>

                <WhyUsContainer>
                    <WhyUsCard>
                        <h4>Experienced Professionals</h4>
                        <p>More than 5 years of expertise in carpentry and renovation.</p>
                    </WhyUsCard>
                    <WhyUsCard>
                        <h4>Custom Solutions</h4>
                        <p>Tailored to meet your unique needs.</p>
                    </WhyUsCard>
                    <WhyUsCard>
                        <h4>Quality Materials</h4>
                        <p>We use only the best for lasting results.</p>
                    </WhyUsCard>
                    <WhyUsCard>
                        <h4>On-Time Delivery</h4>
                        <p>We respect your time and deadlines.</p>
                    </WhyUsCard>
                </WhyUsContainer>

                <CallToAction>
                    <h3>Ready to transform your space? Let’s build something amazing together.</h3>
                    <ContactButton to='/contact'>Contact Us Today</ContactButton>
                </CallToAction>
            </HeroContent>
        </HeroMain>
    );
}

export default HeroSection;
